module.exports = __webpack_public_path__ + "media/images/icons/bi-emoji-frown-ee57983776f8b6c2ee2e961e1617bb8a.png";